
import React, { useState, useEffect } from "react";
// import './EntryLevelLearning.css'
import "./KeyInitiatives.css";
import "../function-components/HomeContent.css";
import "../function-components/SLFComponents/DeliveryOld.css";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import CyberHER from "./CyberHER";
import { Link } from "react-router-dom";
import CyberSecurity from "../function-components/CyberSecurity";

function KeyInitiatives() {
  const [displaySkill, setDisplaySkill] = useState("I&D");

  return (
    <>
      <div className="banner-container">
        <img src="images/Banner1.png" alt="banner" className="banner-img" />
        <MenuNavbar />
      </div>
      <Floaticons />

      <div className="Network_tab_cont2">
        <a
          className={
            displaySkill === "I&D"
              ? "Network_tab_tier-cap-active"
              : "Network_tab_tier-cap-inactive"
          }
          onClick={() => setDisplaySkill("I&D")}
          href="#I&DInitiatives"
        >
          I&D Initiatives
        </a>
        <a
          className={
            displaySkill === "programs"
              ? "Network_tab_tier-mand-active"
              : "Network_tab_tier-mand-inactive"
          }
          onClick={() => {
            setDisplaySkill("programs");
          }}
          href="#ProgramForVeterans"
        >
          Programs for Veterans-Boot to Suit
        </a>
        <a
          className={
            displaySkill === "cybersecurity"
              ? "Network_tab_tier-cross-active"
              : "Network_tab_tier-cross-inactive"
          }
          onClick={() => {
            setDisplaySkill("cybersecurity");
          }}
          href="#cyberSecurity"
        >
          Learning Essentials for Security Newbies
        </a>
      </div>

      <div className="Network_skill_tab" id="KeyInitiatives">
        {displaySkill === "I&D" ? (
          <div className="Network_skill_tile-container">
            <div className="ID-container">
              <div className="IDcontent">
                {/* <h2>I&D Initiatives</h2> */}
                <div className="delivery-main-container">
                  {/* Section 1  */}
                  {/* <div className="key-container">
                    <div className="key-wrap">
                        <div className="key-row">
                            <div className="key-box">
                                <img src="./images/SLF/DFA.png" alt="DFA-img" className="key-imgs" />
                                <div className="key-box-content">
                                    <h2>CyberHER</h2>
                                    <p>
                                        An opportunity for women employees to learn application security concepts to 
                                        develop secure software and help us on our mission to SECURE THE WORLD! <br/>
                                    </p>
                                    <br/>
                                </div>
                            </div>
                            <div className="key-box">
                                <img src="./images/SLF/DFA.png" alt="DFA-img" className="key-imgs" />
                                <div className="key-box-content">
                                    <h2>CyberHER</h2>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea voluptatem tenetur minus consequatur distinctio consequuntur eaque itaque quia incidunt ab nihil ipsum, hic explicabo iure ad temporibus cupiditate aliquam voluptate? <br/>
                                    </p>
                                    <br/>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div> */}

                  <div className="initiatives-container2">
                    <div className="initaitives-wrap">
                      <div className="dp-row row1">
                        <div className="dp-box1">
                          <Link to="/CyberHER" className="cyberlink">
                            <img
                              src="./images/CyberHER-SM.png"
                              alt="dp-img"
                              className=""
                            />
                            <div className="dp-box-content1">
                              <h3>CyberHER</h3>
                              <p>
                                An opportunity for women employees to learn
                                application security concepts to develop secure
                                software and help us on our mission to SECURE
                                THE WORLD! <br />
                              </p>
                              <div className="link-style">
                                <Link to="/CyberHER" className="button">
                                  <button className="knowmore">
                                    Learn More
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </Link>
                        </div>
                        {/* <div className="dp-box1">
                                                <Link to="/CyberHER" className="cyberlink">
                                                    <img src="./images/Hackathon.png" alt="dp-img" className="" />
                                                    <div className="dp-box-content1">
                                                        <h3>Hackathon</h3>
                                                        <p>
                                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae, magni corporis magnam distinctio voluptatum neque earum! Minus in dolore nemo soluta explicabo numquam, fugiat quibusdam pariatur animi architecto possimus reiciendis?
                                                        </p>
                                                        <div className="link-style">
                                                            <Link to="" className="button">
                                                                <button className="knowmore">Know More</button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {displaySkill === "programs" ? <h1>Coming Soon!</h1> : ""}
        {displaySkill === "cybersecurity" ? (
          <div className="Network_skill_tile-container">
            <div className="ID-container">
              <div className="IDcontent">
                <div className="delivery-main-container">
                  {/* Section 1  */}
                  <div className="initiatives-container2">
                    <div className="initaitives-wrap">
                      <div className="dp-row row1">
                        <div className="dp-box1">
                          <Link to="/cyberSecurity" className="cyberlink">
                            <img
                              src="./images/Cybersecurity-SM.png"
                              alt="dp-img"
                              className=""
                            />
                            <div className="dp-box-content1">
                              <h3>Cybersecurity essentials for beginners</h3>
                              <p>
                              This program is exclusively designed for the professionals interested in starting their journey as Cybersecurity Professionals.
                                <br />
                              </p>
                              <div className="link-style">
                                <Link to="/cyberSecurity" className="button">
                                  <button className="knowmore">
                                    Learn More
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </Link>
                        </div>
                        {/* <div className="dp-box1">
                          <Link to="/SailPointIdentityIQ" className="cyberlink">
                            <img
                              src="./images/SailPoint.png"
                              alt="dp-img"
                              className=""
                            />
                            <div className="dp-box-content1">
                              <h3>SailPoint IdentityIQ Program</h3>
                              <p>
                                Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Animi, possimus maiores
                                voluptates quis enim cum et quidem, repudiandae
                                dolorem dolores eaque? Molestias, inventore rem!
                                Hic nobis cupiditate ratione architecto,
                                temporibus eos quae odio voluptatibus porro
                                consequatur atque dolore laborum voluptates!
                                <br />
                              </p>
                              <div className="link-style">
                                <Link
                                  to="/SailPointIdentityIQ"
                                  className="button"
                                >
                                  <button className="knowmore">
                                    Know More
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </Link>
                        </div> */}
                        {/* <div className="dp-box1">
                                                <Link to="/CyberHER" className="cyberlink">
                                                    <img src="./images/Hackathon.png" alt="dp-img" className="" />
                                                    <div className="dp-box-content1">
                                                        <h3>Hackathon</h3>
                                                        <p>
                                                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae, magni corporis magnam distinctio voluptatum neque earum! Minus in dolore nemo soluta explicabo numquam, fugiat quibusdam pariatur animi architecto possimus reiciendis?
                                                        </p>
                                                        <div className="link-style">
                                                            <Link to="" className="button">
                                                                <button className="knowmore">Know More</button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default KeyInitiatives;

